.overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
}

.loaderContainer {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	text-align: center;
}

.loader {
	width: 60px;
	height: 60px;
	border: 8px solid #f3f3f3;
	border-top: 8px solid #7fb02f;
	border-radius: 50%;
	animation: spin 1s linear infinite;
}

.message {
	color: #fff;
	font-size: 1.2rem;
	max-width: 80%;
}
@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}
